import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-terms-of-use',
    templateUrl: './page-terms-of-use.component.html',
    styleUrls: ['./page-terms-of-use.component.scss']
})
export class PageTermsOfUseComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
